(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-with-image"] && !Shopify.designMode) return;
  try {
    
  class AccordionWithImage {
    constructor(container) {
      this.container = container;
      this.accordionCustoms = container.querySelectorAll('accordion-custom');
      this.images = container.querySelectorAll('.accordion-image');

      this.init();
    }

    init() {
      this.accordionCustoms.forEach((accordion) => {
        const details = accordion.querySelector('details');
        if (details) {
          details.addEventListener('toggle', (e) => this.handleToggle(e, accordion));
        }
      });
    }

    handleToggle(event, accordionCustom) {
      const details = event.target;
      const itemId = accordionCustom.dataset.itemId;

      if (details.open) {
        // Close other accordions
        this.accordionCustoms.forEach((otherAccordion) => {
          if (otherAccordion !== accordionCustom) {
            const otherDetails = otherAccordion.querySelector('details');
            if (otherDetails) {
              otherDetails.open = false;
            }
          }
        });

        // Switch to corresponding image
        this.switchToImage(itemId);
      }
    }

    switchToImage(itemId) {
      this.images.forEach((image) => {
        const isActive = image.dataset.itemId === itemId;
        image.classList.toggle('accordion-image--active', isActive);
      });
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    const accordionWithImage = document.querySelector('.accordion-with-image-section');
    if (accordionWithImage) {
      new AccordionWithImage(accordionWithImage);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Hero border pattern repeater
  function initializeHeroBorders() {
    const borderContainers = document.querySelectorAll('[data-border-type]');

    // SVG content for horizontal and vertical borders
    const horizontalSVG = `<svg width="71" height="6" viewBox="0 0 71 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.5 1.02997L71 1.02997M0.5 5.21997L71 5.21997" stroke="#6f6757"/>
</svg>`;

    const verticalSVG = `<svg width="6" height="72" viewBox="0 0 6 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.955029 71.3749L0.95503 0.874939M5.14503 71.3749L5.14503 0.874939" stroke="#6f6757"/>
</svg>`;

    borderContainers.forEach((container) => {
      const borderType = container.dataset.borderType;
      const isHorizontal = borderType === 'horizontal';

      // Get container dimensions
      const containerRect = container.getBoundingClientRect();
      const containerSize = isHorizontal ? containerRect.width : containerRect.height;

      // SVG dimensions
      const svgWidth = isHorizontal ? 71 : 6;
      const svgHeight = isHorizontal ? 6 : 72;
      const svgSize = isHorizontal ? svgWidth : svgHeight;

      // Calculate how many SVGs we need, accounting for the 2px overlap
      const overlap = 2;
      const effectiveSvgSize = svgSize - overlap;
      const svgCount = Math.ceil(containerSize / effectiveSvgSize);

      // Clear existing content
      container.innerHTML = '';

      // Create and append SVG elements directly
      for (let i = 0; i < svgCount; i++) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = isHorizontal ? horizontalSVG : verticalSVG;
        const svgElement = tempDiv.firstElementChild;
        container.appendChild(svgElement);
      }
    });
  }

  // Initialize on DOM ready with a small delay to ensure layout is complete
  function initializeWithDelay() {
    setTimeout(initializeHeroBorders, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWithDelay);
  } else {
    initializeWithDelay();
  }

  // Re-initialize on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initializeHeroBorders, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-fast"]) return;
  try {
    
  // Keep this sibling of priceContainer in sync with the price rebuilt by product-price.js.
  const vhObservedPrices = new WeakSet();
  const vhMoneyNumber = /\d(?:[\d.,'’\s]*\d)?/;

  const vhFormatPerStick = (displayedPrice, sample, count) => {
    if (!Number.isInteger(count) || count <= 0 || /[-−]/.test(displayedPrice)) return '';
    const amount = displayedPrice.match(vhMoneyNumber);
    const sampleAmount = sample.match(vhMoneyNumber)?.[0];
    if (!amount || !sampleAmount) return '';

    // A server-formatted 1234.56 identifies the shop's decimal and grouping separators.
    const decimal = sampleAmount.match(/([.,])\d{2}$/)?.[1] || '';
    const integerSample = decimal ? sampleAmount.slice(0, -3) : sampleAmount;
    const grouping = integerSample.match(/[^\d]/)?.[0] || '';
    const normalized = decimal
      ? amount[0].split(decimal).map((part) => part.replace(/\D/g, '')).join('.')
      : amount[0].replace(/\D/g, '');
    const price = Number(normalized);
    if (!Number.isFinite(price) || price <= 0) return '';

    const cents = Math.round(Math.round(price * 100) / count);
    if (!Number.isFinite(cents)) return '';
    const parts = (cents / 100).toFixed(decimal ? 2 : 0).split('.');
    if (grouping) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, grouping);
    return displayedPrice.slice(0, amount.index) + parts.join(decimal) +
      displayedPrice.slice(amount.index + amount[0].length);
  };

  const vhInitPerStick = (root) => {
    for (const label of root.querySelectorAll('.section-resource-list--vh-homepage [data-vh-stick-counts]')) {
      const priceElement = label.closest('product-price');
      const card = priceElement?.closest('.product-card');
      if (!priceElement || !card || vhObservedPrices.has(priceElement)) continue;

      let counts;
      try {
        counts = JSON.parse(label.dataset.vhStickCounts);
      } catch {
        continue;
      }
      vhObservedPrices.add(priceElement);

      const sync = () => {
        const variantInput = card.querySelector('form[action*="/cart/add"] [name="id"]');
        const variantId = variantInput ? variantInput.value : label.dataset.vhVariantId;
        const count = Number(counts[variantId] || 0);
        const displayedPrice = priceElement.querySelector('[ref="priceContainer"] .price')?.textContent.trim() || '';
        const formatted = count > 0 ? vhFormatPerStick(displayedPrice, label.dataset.vhMoneySample, count) : '';
        const text = formatted ? `${formatted} ${label.dataset.vhPerStickSuffix}` : '';
        // Our text update also triggers the observer; only write when it actually changes.
        if (label.textContent !== text) label.textContent = text;
        if (label.hidden !== !text) label.hidden = !text;
      };

      new MutationObserver(sync).observe(priceElement, { childList: true, subtree: true, characterData: true });
      // Defer until form and price listeners have finished handling the same event.
      const scheduleSync = () => queueMicrotask(sync);
      card.addEventListener('change', scheduleSync);
      card.addEventListener('input', scheduleSync);
      card.addEventListener('variant:update', scheduleSync);
      sync();
    }
  };

  vhInitPerStick(document);
  document.addEventListener('shopify:section:load', (event) => vhInitPerStick(event.target));

  // Click-to-scroll: clicking a peeking (partially visible) slide scrolls it into view
  // instead of following the product link
  const slideshows = document.querySelectorAll('.section-resource-list slideshow-component');

  for (const slideshow of slideshows) {
    const scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller) continue;

    scroller.addEventListener('click', (event) => {
      const slide = event.target.closest('slideshow-slide');
      if (!slide) return;

      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide:not([hidden])'));
      const index = slides.indexOf(slide);
      if (index === -1) return;

      // Check if the clicked slide is fully visible
      const scrollerRect = scroller.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();
      const fullyVisible =
        slideRect.left >= scrollerRect.left - 1 &&
        slideRect.right <= scrollerRect.right + 1;

      if (!fullyVisible) {
        event.preventDefault();
        event.stopPropagation();
        slideshow.select(index);
      }
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  // Keep this sibling of priceContainer in sync with the price rebuilt by product-price.js.
  const vhObservedPrices = new WeakSet();
  const vhMoneyNumber = /\d(?:[\d.,'’\s]*\d)?/;

  const vhFormatPerStick = (displayedPrice, sample, count) => {
    if (!Number.isInteger(count) || count <= 0 || /[-−]/.test(displayedPrice)) return '';
    const amount = displayedPrice.match(vhMoneyNumber);
    const sampleAmount = sample.match(vhMoneyNumber)?.[0];
    if (!amount || !sampleAmount) return '';

    // A server-formatted 1234.56 identifies the shop's decimal and grouping separators.
    const decimal = sampleAmount.match(/([.,])\d{2}$/)?.[1] || '';
    const integerSample = decimal ? sampleAmount.slice(0, -3) : sampleAmount;
    const grouping = integerSample.match(/[^\d]/)?.[0] || '';
    const normalized = decimal
      ? amount[0].split(decimal).map((part) => part.replace(/\D/g, '')).join('.')
      : amount[0].replace(/\D/g, '');
    const price = Number(normalized);
    if (!Number.isFinite(price) || price <= 0) return '';

    const cents = Math.round(Math.round(price * 100) / count);
    if (!Number.isFinite(cents)) return '';
    const parts = (cents / 100).toFixed(decimal ? 2 : 0).split('.');
    if (grouping) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, grouping);
    return displayedPrice.slice(0, amount.index) + parts.join(decimal) +
      displayedPrice.slice(amount.index + amount[0].length);
  };

  const vhInitPerStick = (root) => {
    for (const label of root.querySelectorAll('.section-resource-list--vh-homepage [data-vh-stick-counts]')) {
      const priceElement = label.closest('product-price');
      const card = priceElement?.closest('.product-card');
      if (!priceElement || !card || vhObservedPrices.has(priceElement)) continue;

      let counts;
      try {
        counts = JSON.parse(label.dataset.vhStickCounts);
      } catch {
        continue;
      }
      vhObservedPrices.add(priceElement);

      const sync = () => {
        const variantInput = card.querySelector('form[action*="/cart/add"] [name="id"]');
        const variantId = variantInput ? variantInput.value : label.dataset.vhVariantId;
        const count = Number(counts[variantId] || 0);
        const displayedPrice = priceElement.querySelector('[ref="priceContainer"] .price')?.textContent.trim() || '';
        const formatted = count > 0 ? vhFormatPerStick(displayedPrice, label.dataset.vhMoneySample, count) : '';
        const text = formatted ? `${formatted} ${label.dataset.vhPerStickSuffix}` : '';
        // Our text update also triggers the observer; only write when it actually changes.
        if (label.textContent !== text) label.textContent = text;
        if (label.hidden !== !text) label.hidden = !text;
      };

      new MutationObserver(sync).observe(priceElement, { childList: true, subtree: true, characterData: true });
      // Defer until form and price listeners have finished handling the same event.
      const scheduleSync = () => queueMicrotask(sync);
      card.addEventListener('change', scheduleSync);
      card.addEventListener('input', scheduleSync);
      card.addEventListener('variant:update', scheduleSync);
      sync();
    }
  };

  vhInitPerStick(document);
  document.addEventListener('shopify:section:load', (event) => vhInitPerStick(event.target));

  // Click-to-scroll: clicking a peeking (partially visible) slide scrolls it into view
  // instead of following the product link
  const slideshows = document.querySelectorAll('.section-resource-list slideshow-component');

  for (const slideshow of slideshows) {
    const scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller) continue;

    scroller.addEventListener('click', (event) => {
      const slide = event.target.closest('slideshow-slide');
      if (!slide) return;

      const slides = Array.from(slideshow.querySelectorAll('slideshow-slide:not([hidden])'));
      const index = slides.indexOf(slide);
      if (index === -1) return;

      // Check if the clicked slide is fully visible
      const scrollerRect = scroller.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();
      const fullyVisible =
        slideRect.left >= scrollerRect.left - 1 &&
        slideRect.right <= scrollerRect.right + 1;

      if (!fullyVisible) {
        event.preventDefault();
        event.stopPropagation();
        slideshow.select(index);
      }
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-truths"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const syncPlayback = () => {
      document.querySelectorAll('[data-science-truths-video-frame] video').forEach((video) => {
        video.muted = true;
        if (reducedMotion.matches) {
          video.pause();
        } else {
          video.play().catch(() => {});
        }
      });
    };

    syncPlayback();
    reducedMotion.addEventListener?.('change', syncPlayback);
    document.addEventListener('shopify:section:load', syncPlayback);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-buybox-trilogy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vh-lp-buybox')) {
    customElements.define(
      'vh-lp-buybox',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.dots = this.querySelectorAll('[data-dot]');
          this.select = this.querySelector('[data-plan-select]');
          this.planInput = this.querySelector('[data-selling-plan-input]');
          this.typeInputs = this.querySelectorAll('[data-type-input]');

          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1));
          this.dots.forEach((d) => d.addEventListener('click', () => this.goTo(Number(d.dataset.dot))));
          this.track?.addEventListener('scroll', () => this.syncDots(), { passive: true });
          this.syncDots();

          this.typeInputs.forEach((i) => i.addEventListener('change', () => this.syncType()));
          this.select?.addEventListener('change', () => this.syncPlan());
          this.syncPlan();
        }
        slideWidth() {
          return this.track ? this.track.clientWidth : 0;
        }
        index() {
          const w = this.slideWidth();
          return w ? Math.round(this.track.scrollLeft / w) : 0;
        }
        count() {
          return this.track ? this.track.children.length : 0;
        }
        goTo(i) {
          const n = this.count();
          if (!n) return;
          const idx = (i + n) % n;
          this.track.scrollTo({ left: idx * this.slideWidth(), behavior: 'smooth' });
        }
        go(delta) {
          this.goTo(this.index() + delta);
        }
        syncDots() {
          const i = this.index();
          this.dots.forEach((d, n) => {
            const on = n === i;
            d.classList.toggle('is-active', on);
            d.setAttribute('aria-current', on ? 'true' : 'false');
          });
        }
        isSubscription() {
          const checked = this.querySelector('[data-type-input]:checked');
          return !!checked && checked.value === 'subscription';
        }
        syncType() {
          const sub = this.isSubscription();
          this.querySelector('[data-card="subscription"]')?.classList.toggle('is-selected', sub);
          this.querySelector('[data-card="onetime"]')?.classList.toggle('is-selected', !sub);
          this.syncPlan();
        }
        syncPlan() {
          if (!this.planInput) return;
          const sub = this.isSubscription();
          const opt = this.select ? this.select.selectedOptions[0] : null;
          if (sub && opt) {
            this.planInput.disabled = false;
            this.planInput.value = opt.value;
          } else {
            this.planInput.disabled = true;
            this.planInput.value = '';
          }
          if (opt) {
            const price = this.querySelector('[data-sub-price]');
            const per = this.querySelector('[data-sub-per]');
            const save = this.querySelector('[data-save-percent]');
            if (price) price.innerHTML = opt.dataset.priceHtml;
            if (per) per.textContent = opt.dataset.per || '';
            if (save) save.textContent = Number(opt.dataset.save) > 0 ? (save.dataset.saveLabel || '').replace('[percent]', opt.dataset.save) : '';
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-elixir-carousel-arch-dark"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vh-lp-eca')) {
  customElements.define(
    'vh-lp-eca',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.arches = Array.from(this.querySelectorAll('[data-arch]'));
        this.details = Array.from(this.querySelectorAll('[data-detail]'));
        this.n = this.arches.length;
        this.active = 0;
        this.moved = false;

        this.arches.forEach((arch, i) => {
          arch.addEventListener('click', () => {
            if (this.moved) return;
            this.stopAuto();
            this.select(i);
          });
        });

        // Swipe: a horizontal drag of more than 40px steps to the next or previous arch.
        let startX = null;
        let startY = null;
        this.track.addEventListener('pointerdown', (e) => {
          startX = e.clientX;
          startY = e.clientY;
          this.moved = false;
        });
        const end = (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          startX = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.moved = true;
            this.stopAuto();
            this.select(this.active + (dx < 0 ? 1 : -1));
            setTimeout(() => { this.moved = false; }, 0);
          }
        };
        this.addEventListener('pointerup', end);
        this.addEventListener('pointercancel', () => { startX = null; });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.select(this.active - 1);
          if (e.key === 'ArrowRight') this.select(this.active + 1);
        });
        this.addEventListener('shopify:block:select', (e) => {
          const i = Array.from(this.querySelectorAll('.vh-lp-eca__item')).indexOf(e.target.closest('.vh-lp-eca__item') || e.target);
          if (i > -1) this.select(i);
        });

        this.select(0);
        this.startAuto();
      }

      disconnectedCallback() {
        this.stopAuto();
      }

      select(i) {
        if (this.n < 1) return;
        this.active = Math.max(0, Math.min(this.n - 1, i));
        this.style.setProperty('--vh-ca-i', String(this.active));
        this.style.setProperty('--vh-ca-j', this.active > 0 ? '1' : '0');
        this.arches.forEach((a, k) => {
          a.setAttribute('aria-current', k === this.active ? 'true' : 'false');
        });
        this.details.forEach((d, k) => d.classList.toggle('is-active', k === this.active));
      }

      startAuto() {
        if (this.dataset.autoplay !== 'true' || this.n < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const ms = (parseInt(this.dataset.interval, 10) || 5) * 1000;
        this.timer = setInterval(() => this.select((this.active + 1) % this.n), ms);
        this.addEventListener('pointerenter', () => this.stopAuto(), { once: true });
      }

      stopAuto() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-elixir-coverflow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vh-lp-ec')) {
  customElements.define(
    'vh-lp-ec',
    class extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.details = Array.from(this.querySelectorAll('[data-detail]'));
        this.n = this.cards.length;
        this.active = 0;
        const track = this.querySelector('[data-track]');
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        const press = (btn) => {
          btn.classList.add('is-pressed');
          setTimeout(() => btn.classList.remove('is-pressed'), 250);
        };
        if (prev) prev.addEventListener('click', () => { press(prev); this.go(-1); });
        if (next) next.addEventListener('click', () => { press(next); this.go(1); });

        // Swipe on the cards.
        let startX = null;
        let startY = null;
        track.addEventListener('pointerdown', (e) => { startX = e.clientX; startY = e.clientY; });
        track.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          startX = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(dx < 0 ? 1 : -1);
        });
        track.addEventListener('pointercancel', () => { startX = null; });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(-1);
          if (e.key === 'ArrowRight') this.go(1);
        });
        this.render();
      }

      go(step) {
        if (this.n < 2) return;
        this.active = (this.active + step + this.n) % this.n;
        this.render();
      }

      render() {
        const half = Math.floor(this.n / 2);
        this.cards.forEach((card, i) => {
          let rel = (i - this.active + this.n + half) % this.n - half;
          if (this.n % 2 === 0 && rel === -half) rel = half;
          card.dataset.pos = Math.abs(rel) > 1 ? 'hidden' : String(rel);
          card.setAttribute('aria-hidden', rel === 0 ? 'false' : 'true');
        });
        this.details.forEach((d, i) => d.classList.toggle('is-active', i === this.active));
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-elixir-picker-framed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vh-lp-pf')) {
  customElements.define(
    'vh-lp-pf',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.n = this.items.length;
        this.active = Math.min(Math.max(parseInt(this.dataset.start, 10) || 0, 0), Math.max(this.n - 1, 0));
        this.items.forEach((item, i) => {
          item.querySelector('[data-select]').addEventListener('click', () => {
            if (this.swiped) return;
            this.set(i);
          });
        });

        // Swipe on the track.
        let startX = null;
        let startY = null;
        this.swiped = false;
        this.track.addEventListener('pointerdown', (e) => {
          startX = e.clientX;
          startY = e.clientY;
          this.swiped = false;
        });
        this.track.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          const dy = e.clientY - startY;
          startX = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.swiped = true;
            this.set(this.active + (dx < 0 ? 1 : -1));
            setTimeout(() => { this.swiped = false; }, 50);
          }
        });
        this.track.addEventListener('pointercancel', () => { startX = null; });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.set(this.active - 1);
          if (e.key === 'ArrowRight') this.set(this.active + 1);
        });
        this.mq = window.matchMedia('(max-width: 749px)');
        this.resizeHandler = () => this.render(true);
        window.addEventListener('resize', this.resizeHandler);
        window.addEventListener('load', this.resizeHandler);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.resizeHandler);
          this.observer.observe(this);
        }
        this.render(true);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
        window.removeEventListener('load', this.resizeHandler);
        if (this.observer) this.observer.disconnect();
      }

      set(i) {
        if (i < 0 || i >= this.n || i === this.active) return;
        this.active = i;
        this.render(false);
      }

      render(instant) {
        this.items.forEach((item, i) => {
          item.classList.toggle('is-active', i === this.active);
          item.querySelector('[data-select]').setAttribute('aria-pressed', i === this.active ? 'true' : 'false');
        });
        if (!this.mq.matches) {
          this.track.style.setProperty('--pf-tx', '0px');
          return;
        }
        // Mobile: slide the track so the active card sits where Figma puts it (centre 203.45 of 402).
        const probe = document.createElement('span');
        probe.style.cssText = 'position:absolute;visibility:hidden;width:calc(var(--pf-cu) * 1000)';
        this.appendChild(probe);
        const cu = probe.getBoundingClientRect().width / 1000;
        probe.remove();
        const small = 478.3 * cu;
        const big = 592.67 * cu;
        const gap = 36.4 * cu;
        let left = 0;
        for (let i = 0; i < this.active; i++) left += small + gap;
        const center = left + big / 2;
        const target = (this.clientWidth * 203.45) / 402;
        if (instant) {
          this.track.style.transition = 'none';
        }
        this.track.style.setProperty('--pf-tx', target - center + 'px');
        if (instant) {
          void this.track.offsetWidth;
          this.track.style.transition = '';
        }
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-formula-diagram-glass"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vhLpFdgReady) return;
    root.dataset.vhLpFdgReady = '1';
    var frames = Array.prototype.slice.call(root.querySelectorAll('[data-vh-lp-fdg-frame]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vh-lp-fdg-dot]'));
    var circle = root.querySelector('[data-vh-lp-fdg-circle]');
    var current = 0;
    var timer = null;
    function show(i) {
      if (!frames.length) return;
      current = (i + frames.length) % frames.length;
      frames.forEach(function (f, n) { f.classList.toggle('is-active', n === current); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === current); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (root.dataset.autoplay !== 'true' || reduce || frames.length < 2) return;
      timer = setInterval(function () { show(current + 1); }, Math.max(2, parseInt(root.dataset.interval, 10) || 3) * 1000);
    }
    if (circle) circle.addEventListener('click', function () { show(current + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-vh-lp-fdg-dot'), 10) || 0); start(); });
    });
    start();
  }
  function initAll() { document.querySelectorAll('[data-vh-lp-fdg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-make-it-yours-arch"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vhMiyReady) return;
    root.dataset.vhMiyReady = '1';
    var arch = root.querySelector('[data-vh-miy-arch]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-vh-miy-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vh-miy-dot]'));
    if (!arch || slides.length < 2) return;
    var index = 0;
    var timer = null;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        if (on) { slide.removeAttribute('aria-hidden'); slide.removeAttribute('tabindex'); }
        else { slide.setAttribute('aria-hidden', 'true'); slide.setAttribute('tabindex', '-1'); }
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
    }
    function restart() {
      if (timer) { clearInterval(timer); timer = null; }
      var seconds = parseInt(root.dataset.interval, 10) || 5;
      if (root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(function () { show(index + 1); }, seconds * 1000);
      }
    }

    slides.forEach(function (slide) {
      slide.addEventListener('click', function () {
        if (arch.dataset.swiped) { delete arch.dataset.swiped; return; }
        show(index + 1);
        restart();
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { show(parseInt(dot.dataset.vhMiyDot, 10)); restart(); });
    });

    var startX = null;
    arch.addEventListener('pointerdown', function (e) { startX = e.clientX; });
    arch.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) {
        arch.dataset.swiped = '1';
        show(index + (dx < 0 ? 1 : -1));
        restart();
        setTimeout(function () { delete arch.dataset.swiped; }, 0);
      }
    });
    arch.addEventListener('pointercancel', function () { startX = null; });
    restart();
  }

  function initAll() {
    document.querySelectorAll('[data-vh-miy]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-quest-tabs-arch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vh-lp-qta')) {
  customElements.define(
    'vh-lp-qta',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.pics = Array.from(this.querySelectorAll('[data-pic]'));
        this.n = this.tabs.length;
        this.active = 0;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => {
            this.stopAuto();
            this.select(i);
          });
        });
        this.addEventListener('keydown', (e) => {
          if (!e.target.closest || !e.target.closest('[data-tab]')) return;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
            e.preventDefault();
            this.stopAuto();
            this.select((this.active + 1) % this.n, true);
          }
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
            e.preventDefault();
            this.stopAuto();
            this.select((this.active - 1 + this.n) % this.n, true);
          }
        });
        this.addEventListener('shopify:block:select', (e) => {
          const items = Array.from(this.querySelectorAll('.vh-lp-qta__item'));
          const pics = this.pics;
          let i = items.indexOf(e.target.closest('.vh-lp-qta__item') || e.target);
          if (i < 0) i = pics.indexOf(e.target.closest('[data-pic]') || e.target);
          if (i > -1) this.select(i);
        });

        this.select(0);
        this.startAuto();
      }

      disconnectedCallback() {
        this.stopAuto();
      }

      select(i, focus) {
        if (this.n < 1) return;
        this.active = Math.max(0, Math.min(this.n - 1, i));
        this.tabs.forEach((t, k) => {
          const on = k === this.active;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.pics.forEach((p, k) => p.classList.toggle('is-active', k === this.active));
        if (focus) this.tabs[this.active].focus();
      }

      startAuto() {
        if (this.dataset.autoplay !== 'true' || this.n < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const ms = (parseInt(this.dataset.interval, 10) || 5) * 1000;
        this.timer = setInterval(() => this.select((this.active + 1) % this.n), ms);
        this.addEventListener('pointerenter', () => this.stopAuto(), { once: true });
      }

      stopAuto() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-recipes-framed-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-vh-lp-recipes-track]');
    if (!track || track.dataset.vhInit) return;
    track.dataset.vhInit = '1';
    var cards = track.children;
    if (cards.length > 2 && window.matchMedia('(max-width: 749px)').matches) {
      // Mobile design: second card centred, neighbours peeking.
      var card = cards[1];
      track.scrollLeft = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    }
  }
  function run() {
    document.querySelectorAll('[data-vh-lp-recipes]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-ugc-review-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-vh-lp-ugc-track]');
    if (!track || track.dataset.vhInit) return;
    track.dataset.vhInit = '1';
    // Desktop mouse drag scrolls the track (touch uses native scrolling).
    var down = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest && e.target.closest('video')) return;
      down = { x: e.clientX, left: track.scrollLeft, moved: false };
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - down.x;
      if (!down.moved && Math.abs(dx) < 4) return;
      if (!down.moved) {
        down.moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      track.scrollLeft = down.left - dx;
    });
    function end(e) {
      if (!down) return;
      var moved = down.moved;
      down = null;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      if (moved) track.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    var cards = track.children;
    if (cards.length > 2 && window.matchMedia('(max-width: 749px)').matches) {
      // Mobile design shows the second card centred with its neighbours peeking.
      var card = cards[1];
      track.scrollLeft = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    }
  }
  function run() {
    document.querySelectorAll('[data-vh-lp-ugc]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-ugc-review-dashed"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-vh-lp-ugcd-track]');
    if (!track || track.dataset.vhInit) return;
    track.dataset.vhInit = '1';
    var cards = track.children;
    if (cards.length > 2 && window.matchMedia('(max-width: 749px)').matches) {
      // Mobile design shows the second card centred with its neighbours peeking.
      var card = cards[1];
      track.scrollLeft = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    }

    // Mouse drag to scroll. Touch and pen keep native scrolling and snap.
    track.classList.add('is-grabbable');
    var down = false, moved = false, startX = 0, startLeft = 0, pid = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft; pid = e.pointerId;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(pid); } catch (err) {}
      }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    function end(e) {
      if (!down || (e && e.pointerId !== pid)) return;
      down = false;
      if (moved) {
        try { track.releasePointerCapture(pid); } catch (err) {}
        track.classList.remove('is-dragging');
      }
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function run() {
    document.querySelectorAll('[data-vh-lp-ugcd]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-lp-ugc-review-outline"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-vh-lp-ugcol-track]');
    if (!track || track.dataset.vhInit) return;
    track.dataset.vhInit = '1';
    var cards = track.children;
    if (cards.length > 2 && window.matchMedia('(max-width: 749px)').matches) {
      // Mobile design shows the second card centred with its neighbours peeking.
      var card = cards[1];
      track.scrollLeft = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    }
    // Mouse drag scrolls the track on desktop. Touch and pen keep native scrolling.
    var down = null;
    var moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = { x: e.clientX, left: track.scrollLeft };
      moved = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down || e.pointerType !== 'mouse') return;
      var dx = e.clientX - down.x;
      if (!moved && Math.abs(dx) < 4) return;
      if (!moved) {
        moved = true;
        track.classList.add('is-dragging');
      }
      track.scrollLeft = down.left - dx;
    });
    function end() {
      if (!down) return;
      down = null;
      track.classList.remove('is-dragging');
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function run() {
    document.querySelectorAll('[data-vh-lp-ugcol]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();
})();
